/* global userTimezone -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/slider';

import './common/formatter';
import './common/mobile.menu';
import './common/map_states';
import '../plugins/dl-menu/js/jquery.dlmenu';
import 'select2/dist/js/select2.min';
import './common/client-directory';
import './common/footer';

import 'parsleyjs';
import './common/parsley.validation.custom.rules';

import * as Sentry from '@sentry/browser';
import '@selectize/selectize/dist/js/selectize';

import { formatISO, parse } from 'date-fns';

import Inputmask from 'inputmask';
import NumberInput from '@components/input/in-number';
import IntegerInput from '@components/input/in-integer';
import SelectInput from '@components/input/in-select';
import SelectMultiInput from '@components/input/in-select-multi';
import TagsInput from '@components/input/in-tags';
import PasswordInput from '@components/input/in-password';
import UrlSlugInput from '@components/input/in-url-slug';
import MinMaxRangeInput from '@components/input/in-min-max-range';
import ChargeOverCustomerInput from '@components/input/chargeover-customer';
import ClientInput from '@components/input/client';
import RadioCardAccordion from '@components/input/in-radio-card-accordion';
import MultiToggleInput from '@components/input/in-multi-toggle';
import TooltipPlugin from '@components/tooltip';
import PopoverPlugin from '@components/popover';
import RangeSliderPlugin from '@components/range-slider';
import MultiselectPlugin from '@components/multiselect';
import PeityChartsPlugin from '@components/peity-charts';
import KnobPlugin from '@components/knob';
import CirclifulPlugin from '@components/circliful';
import CounterUpPlugin from '@components/counter-up';
import NavBar from '@components/nav-bar';
import Expandable from './common/expandable';
import 'bootstrap-rating';
import '@common/components/accordion';

$(() => {
    RadioCardAccordion.init();

    Sentry.init({
        enabled: process.env.SENTRY_ENABLED === 'true',
        dsn: process.env.MIX_SENTRY_DSN,
        ignoreErrors: [
            /find_pos/i,
            /MoatMAK/i,
            /mraid/i,
            /vungle/i,
            /webview/i,
            // todo: remove me
            /Cannot read property '0' of undefined/i,
            // ZenDesk is throwing errors in sentry over cross origin requests because 2/3 of the iframes point to about:blank
            /SecurityError: Blocked a frame with origin/i,
            // the facebook js file is throwing errors internally
            /Not enough arguments/i,

            // AddThis errors
            /Cannot read property 'split' of undefined/i,
            /null is not an object \(evaluating 'document\.body\.scrollLeft'\)/i,

            // AppCast errors
            /MaxTouchPoints/i,

            // 2025-02-13: Google bug? https://github.com/The-Best-Codes/bestcodes-react-site/issues/65
            /ReferenceError: Can't find variable: gmo/i,
            // Belongs to the same stack trace as above
            /TypeError: undefined is not an object \(evaluating 'a\.K'\)/i,
        ],
        // Trying to remove the noise
        // @see https://github.com/getsentry/sentry-javascript/issues/3147#issuecomment-768978043
        beforeSend(event) {
            try {
                if (event.exception.values[0].stacktrace.frames[0].filename === '<anonymous>') {
                    return null;
                }
            } catch {
                // don't
            }

            return event;
        },
    });
    window.Parsley.on('field:error', function() {
        let $input = this.$element;

        if (this.$element.is('select')) {
            $input = $input.closest('.select-wrapper');
        }

        $input.siblings('.help-text').hide();
    });

    window.Parsley.on('field:success', function() {
        let $input = this.$element;

        if (this.$element.is('select')) {
            $input = $input.closest('.select-wrapper');
        }

        $input.siblings('.help-text').show();
    });

    $(document).on('show.bs.modal', '.modal', function() {
        $(this).attr('data-modal-state', 'showing');
    });

    $(document).on('shown.bs.modal', '.modal', function() {
        $(this).attr('data-modal-state', 'shown');
    });

    $(document).on('hide.bs.modal', '.modal', function() {
        $(this).attr('data-modal-state', 'hiding');
    });

    $(document).on('hidden.bs.modal', '.modal', function() {
        $(this).attr('data-modal-state', 'hidden');
    });
});

window.Popper = require('popper.js').default;

$('.select2').select2();

// DataTable pagination
window.dataTableDom = "<'select-wrapper' l>" +
    "<'row mb-2'<'col-sm-6'i><'col-sm-6'p>>" +
    "<'row mb-2'<'col-sm-12'tr>>" +
    "<'row mb-2'<'col-sm-5'i><'col-sm-7'p>>";

/**
 * Component behavior.
 */

NumberInput.init();
IntegerInput.init();
SelectInput.init();
SelectMultiInput.init();
TagsInput.init();
PasswordInput.init();
UrlSlugInput.init();
MinMaxRangeInput.init();
ClientInput.init();
ChargeOverCustomerInput.init();
MultiToggleInput.init();
TooltipPlugin.init($);
PopoverPlugin.init($);
RangeSliderPlugin.init($);
MultiselectPlugin.init($);
PeityChartsPlugin.init($);
KnobPlugin.init($);
CirclifulPlugin.init($);
CounterUpPlugin.init($);
NavBar.init($);

/**
 * Other Functionality.
 */
Expandable.init();

/**
 * in-date
 */
(function() {
    $('.datepicker-autoclose').each(function() {
        const $input = $(this);
        const defaultDate = $input.data('default-date');
        const maxDate = $input.data('max-date');
        const minDate = $input.data('min-date');
        const yearRange = $input.data('year-range');
        const options = {
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
        };

        if (defaultDate !== undefined) {
            options.defaultDate = new Date(defaultDate);
        }

        if (maxDate !== undefined) {
            options.maxDate = new Date(maxDate);
        }

        if (minDate !== undefined) {
            options.minDate = new Date(minDate);
        }

        if (yearRange !== undefined) {
            options.yearRange = `c-${yearRange}:c+${yearRange}`;
        }

        $input.datepicker(options);
    });

    const _gotoToday = jQuery.datepicker._gotoToday;
    jQuery.datepicker._gotoToday = function(a) {
        const target = jQuery(a);
        const inst = this._getInst(target[0]);
        _gotoToday.call(this, a);
        let currentDate = typeof userTimezone !== 'undefined' ? new Date().toLocaleDateString('en-US', { timeZone: userTimezone }) : new Date().toLocaleDateString();
        currentDate = new Date(currentDate);
        jQuery.datepicker._selectDate(a, jQuery.datepicker._formatDate(inst, currentDate.getDate(), currentDate.getMonth(), currentDate.getFullYear()));
    };

    const _generateHTML = $.datepicker._generateHTML;
    $.datepicker._generateHTML = function(inst) {
        let html = _generateHTML.call(this, inst);

        let currentDate = typeof userTimezone !== 'undefined' ? new Date().toLocaleDateString('en-US', { timeZone: userTimezone }) : new Date().toLocaleDateString();
        currentDate = new Date(currentDate);

        const today = currentDate.getDate();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();

        if (html.includes("data-year='" + year + "'") && html.includes("data-month='" + month + "'")) {
            html = html.replace(/\bui-state-highlight\b/g, '');

            const currentDateElement = html.match(new RegExp("<a[^>]*?data-date='" + today + "'[^>]*?>(.*?)</a>"));

            if (currentDateElement && currentDateElement.length > 0) {
                const highlightDayClass = 'ui-state-highlight';
                html = html.replace(currentDateElement[0], currentDateElement[0].replace("class='", "class='" + highlightDayClass + ' '));
            }
        }
        return html;
    };

    Inputmask('99/99/9999', { placeholder: 'mm/dd/yyyy', showMaskOnHover: false }).mask(document.querySelectorAll('.in-date'));
})();

/**
 * in-phone
 */
Inputmask({ mask: '(999) 999-9999' }).mask(document.querySelectorAll('.in-phone'));

/**
 * in-code (verification code)
 */
Inputmask({ mask: '999999' }).mask(document.querySelectorAll('.in-code'));

/**
 * in-date-time
 */
$(document).on('change', '.in-date-time-date,.in-date-time-time', function() {
    const $dateTime = $(this).closest('.in-date-time');
    const date = $dateTime.find('.in-date-time-date').val();
    const time = $dateTime.find('.in-date-time-time').val();
    const value = date && time
        ? formatISO(parse(`${date} ${time}`, 'MM/dd/yyyy h:mm:ss a', new Date()))
        : '';

    $dateTime.find('.in-date-time-value')
        .val(value)
        .trigger('change');
});

/**
 * in-time
 */
$(document).on('change', '.in-time select', function() {
    const $time = $(this).closest('.in-time');
    const h = $time.find('.in-time-hours').val();
    const m = $time.find('.in-time-minutes').val();
    const s = $time.find('.in-time-seconds').val();
    const a = $time.find('.in-time-ampm').val();

    $time.find('.in-time-value')
        .val(`${h}:${m}:${s} ${a}`)
        .trigger('change');
});

/**
 * select
 */
$('select').on('change', function() {
    $(this).toggleClass('unselected', $(this).val() === '');
});

/**
 * Auto-fill
 */
$(document).on('input', 'input[data-autofill]', function() {
    const $input = $(this);
    const targets = $input.data('autofill')
        .split(',');

    targets.forEach(target => $(target).val($input.val()));
});

/**
 * Auto-fill URL slug
 */
$(document).on('input', 'input[data-autofill-slug]', function() {
    const $input = $(this);
    const targets = $input.data('autofill-slug')
        .split(',');

    targets.forEach((target) => {
        const slug = $input.val()
            .trim()
            .toLowerCase()
            .replace(/\s|_/g, '-')
            .replace('&', 'and')
            .replace(/[^a-z0-9-]/g, '')
            .replace(/-{2,}/g, '-')
            .replace(/^-|-$/g, '');

        $(target).val(slug);
    });
});

/**
 * TinyMCE modals
 */
$(document).on('focusin', function(e) {
    if ($(e.target).closest('.tox-dialog').length) {
        e.stopImmediatePropagation();
    }
});
